import {inject, injectable} from "inversify";
import {Sponsor} from "@/modules/sponsoring/entity";
import {Team} from "@/modules/team/entity";
import {BankCategory} from "@/modules/finances/enums";
import GateManager from "@/modules/action-points/services/GateManager";
import {GateTypeEnum} from "@/modules/action-points/enums";

@injectable()
export default class SponsoringHandler {
  constructor(
    @inject(GateManager) private gateManager: GateManager,
  ) {
  }

  public async accept(sponsor: Sponsor, team: Team) {
    const acceptedSponsor = await Sponsor.findOne({
      where: {
        accepted: true,
      }
    });

    if (acceptedSponsor) {
      throw 'Can not accept sponsor. Already accepted exist.';
    }

    sponsor.accepted = true;
    await sponsor.save();

    await this.gateManager.getGate(GateTypeEnum.BALANCE).currency.add(
      sponsor.once,
      {
        category: BankCategory.SPONSORING,
        label: translator.t('accepted_sponsoring'),
      }
    );
  }
}
